import React from 'react';
import ReactDOM from 'react-dom';
import {ConfigProvider, Empty, Spin, Table, Typography, Checkbox } from 'antd';
import {get, post, postSync} from '../utils/http'
import {isEmpty} from "../utils/StringUtils";
import store from '../../store';
import {formMomentFormat} from "../utils/ObjectUtils";
import {clone} from "../../common/utils/ObjectUtils"
import {getExportLimit, getLanguage, getPaginationLanguage, USER_ID} from "../../source/js/common";
import $ from 'jquery';
import cookie from "react-cookies";
import {aisinoInfoModal} from "../modal/AisinoModalMethod";
import { Resizable } from 'react-resizable';
import 'antd/dist/antd.css';
import '../../source/css/table.css';
import {SettingOutlined} from '@ant-design/icons';

const commonLan = require('../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

const {Text} = Typography;

const added="added";
const modified="modified";
const locale = getPaginationLanguage();
const ResizeableTitle = props => {
    const { onResize, width, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={width}
            height={0}
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} />
        </Resizable>
    );
};
class AisinoTable extends React.Component{

    constructor(props){
        super(props);
        // 克隆 props.columns，避免直接修改父组件传递的 props
        const propsColumns = clone(props.columns);
        console.log(props)

        // 初始化变量
        const variableTitles = propsColumns.filter(column => column.variable === true).map(column => column.title);
        const options = propsColumns.filter(column => column.variable === true).map(column => ({
            label: column.title,
            value: column.title,
            key: column.title,
        }));

        if (variableTitles.length > 0) {
            const cachedCheckedList = props.cacheKey ? sessionStorage.getItem(props.cacheKey + cookie.load(USER_ID)) : null;
            const checkedList = cachedCheckedList != null ? JSON.parse(cachedCheckedList) : variableTitles;
            this.state={
                ...this.state,
                options: options,
                checkedList: checkedList,
                variableTitles: variableTitles,
              
            };

            // Dropdown 渲染菜单
            // propsColumns.splice(0,0,
            //     {
            //         title:() => (
            //             <SettingOutlined ref={(ref) => this.headBtnRef = ref} style={{ color: '#fff' }} onClick={this.selectClick}/>
            //         ),
            //         dataIndex: 'variable',
            //         width: 30,
            //     }
            // );
        }


        this.state={
            ...this.state,
            checkBoxShow: false,
            dataSource:props.dataSource?props.dataSource:[],
            loadParams:{},
            allColumns:propsColumns,
            columns:propsColumns,
            sumData:props.sumdata || undefined,
            hiddenCols:[],
            scroll:props.scroll,
            pagination:props.pagination,
            loadUrl:props.loadUrl,
            selectedRowKeys:[],
            dictArr:[],
            searchCloseFlag:false,
            pageChangeFun:props.pageChangeFun,
            selectionType:"radio",
            rowSelection:false,
            rowKeyNum:0,
            locale:locale,
            searchFun:null,
            total:0,
            rowIndeterminate: false ,  // 半选状态
            rowCheckAll:  false,  // "全选"的状态
        };
        this.getDefaultSelection(props.rowSelection);
        this.handleStoreSearchForm = this.handleStoreSearchForm.bind(this);
        store.subscribe(this.handleStoreSearchForm);
        this.components = {
            header: {
                cell: ResizeableTitle,
            },
        };
    }
    onRowCheckAllChange = (e) => {
        const checked = e.target.checked;
        this.setState({
            rowCheckAll: checked,
            rowIndeterminate: false,
            selectedRowKeys: checked ? this.state.dataSource.map(item => item._rowKey) : [],
        });
    }
    onRowSelectChange = (checked,key) => {
        const { selectedRowKeys, dataSource } = this.state;
        this.setState({
            rowIndeterminate: selectedRowKeys.length > 0 && selectedRowKeys.length < dataSource.length,
            rowCheckAll: selectedRowKeys.length === dataSource.length,
        });
    };

    //组件更新
    componentDidUpdate(prevProps) {
        if (prevProps.sumdata !== this.props.sumdata) {
            // 在 sumdata 更新时执行的代码
            this.setState({sumData:this.props.sumdata})
        }
    }

    componentWillMount() {
        // 在组件挂载时，添加事件监听器
        if (this.props.cacheKey && this.state.variableTitles.length > 0) {
            this.onCheckboxChange(this.state.checkedList)
        }
        document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        // 在组件卸载时，移除事件监听器
        if (this.props.cacheKey && this.state.variableTitles.length > 0) {
            sessionStorage.setItem(this.props.cacheKey + cookie.load(USER_ID), JSON.stringify(this.state.checkedList));
        }
        document.removeEventListener('click', this.handleDocumentClick);
    }

    // 处理点击文档时的事件
    handleDocumentClick = (event) => {
        // 检查点击的位置是否在组件内部
        if (this.headBtnRef && !this.headBtnRef.contains(event.target)) {
            if (this.checkboxRef && !this.checkboxRef.contains(event.target) && this.state.checkBoxShow) {
                // 如果点击的是复选框外部，隐藏组件
                this.setState({ checkBoxShow: false });
            }
        }
    };

    //筛选图标点击
    selectClick = (e) => {
        this.setState((prevState) => ({
            checkBoxShow: !prevState.checkBoxShow, // 切换 checkBoxShow 的值
        }));
    }

    // 处理复选框变化
    onCheckboxChange = (checkedValues)=>{
        const { options } = this.state;
        const columns = this.state.allColumns.filter(column => !this.state.variableTitles.includes(column.title) || checkedValues.includes(column.title));
        this.setState({
            columns,
            checkedList:checkedValues,
            indeterminate: checkedValues.length > 0 && checkedValues.length < options.length,
            checkAll: checkedValues.length === options.length,
        });
    }
    // 处理全选的点击事件
    onCheckAllChange = (e) => {
        const { options ,allColumns ,variableTitles } = this.state;
        this.setState({
            checkedList: e.target.checked ? options.map(option => option.value) : [],
            indeterminate: false,
            checkAll: e.target.checked,
            columns:  e.target.checked ? allColumns
                : allColumns.filter(column => !variableTitles.includes(column.title)),
        });
    };

    handleResize = index => (e, { size }) => {
        this.setState(({ columns }) => {
            const nextColumns = [...columns];
            nextColumns[index] = {
                ...nextColumns[index],
                width: size.width,
            };
            return { columns: nextColumns };
        });
    };

    handleStoreSearchForm(){
        this.setState({
            searchCloseFlag:store.getState().handleSearchFormDisplay.displayFlag
        })
    }
    loadTableData(loadParams,pageIndex,pageSize,fun) {
        loadParams=formMomentFormat(loadParams);
        const that = this;
        that.setState({dataSource:[],rowCheckAll:false,
            rowIndeterminate:false});
        loadParams=loadParams?loadParams:{};
        if(isEmpty(this.props.pagination)||this.props.pagination){
            loadParams.pageIndex = pageIndex?pageIndex:0;
            loadParams.pageSize = pageSize?pageSize:cookie.load("gridPageSizeParam");
        }
        postSync(that.state.loadUrl, loadParams,true).then(response => {
            if (!isEmpty(response)) {
                let data = response.records?response.records:response;
                if(!isEmpty(data)&&data.length>0){
                    //let index=0;
                    data.forEach((record)=>{
                        record._rowKey=this.state.rowKeyNum++;
                        // if(record.id){
                        //     record._rowKey=record.id;
                        // }else{
                        //     record._rowKey=new Date().getTime()+""+index++;
                        // }
                    });
                }
                that.state.dataSource = data;
                that.state.loadParams=loadParams;
                if(that.state.pagination!==false&&!isEmpty(response.Page)){
                    that.handlePagination(response.Page.totalSize);
                    that.state.total=response.Page.totalSize;
                }
                that.setState({},function(){
                    if(fun){
                        that.state.searchFun=fun;
                        fun(data);
                    }
                });
            }else{
                that.state.dataSource = [];
                that.state.loadParams=loadParams;
                that.setState({},function(){
                    if(fun){
                        that.state.searchFun=fun;
                        fun([]);
                    }
                });
            }
        })
    }
    handlePagination(total){
        const that  = this;
        let pageSizeOptionsStr = cookie.load("gridSizeListParam");
        if(isEmpty(pageSizeOptionsStr)){
            pageSizeOptionsStr = "15,50,100,200,1000";
        }
        let pageSizeOptionArr = [];
        for(let i =0;i<pageSizeOptionsStr.split(',').length;i++){
            pageSizeOptionArr.push(pageSizeOptionsStr.split(',')[i]);
        }
        that.state.pagination={
            showSizeChanger:true,
            pageSizeOptions:pageSizeOptionArr,
            total: total,
            showTotal:(total, range) => `${range[0]}-${range[1]}  `+commonLan.pageOf.label+` ${total} `+commonLan.pageItems.label,
            current:that.state.loadParams.pageIndex+1,
            pageSize:that.state.loadParams.pageSize,
            defaultCurrent:1,
            defaultPageSize:cookie.load("gridPageSizeParam"),
            locale:that.state.locale,
            onChange:function(current,pageSize){
                that.loadTableData(that.state.loadParams,current-1,pageSize,that.state.searchFun);
                if(that.state.pageChangeFun){
                    that.state.pageChangeFun();
                }
            },
            onShowSizeChange:function(current,pageSize){
                that.loadTableData(that.state.loadParams,0,pageSize,that.state.searchFun);
            }

        }
    }
    getPagination(){
        return this.state.pagination;
    }
    setUrl(url){
        this.state.loadUrl=url;
    }
    setData=(rows,fun)=>{
        if(!isEmpty(rows)){
            //let index=0;
            rows.forEach(row=>{
                row._rowKey=this.state.rowKeyNum++;
                // if(isEmpty(row.id)){
                //     row._rowKey=new Date().getTime()+""+index++;
                // }else{
                //     row._rowKey=row.id;
                // }
            })
        }else{
            rows = [];
        }
        if(fun){
            fun();
        }
        this.state.dataSource=[].concat(rows);
        this.setState({
            rowCheckAll:false,
            rowIndeterminate:false
        });
    };
    refresh(){
        this.setState({
            dataSource:[].concat(this.state.dataSource),
            rowCheckAll:false,
            rowIndeterminate:false

        });
    };
    getData=()=>{
        return clone(this.state.dataSource);
    };
    componentDidMount() {
        this.columnsHandle()
    }

    columnsHandle(){
        const that=this;
        let columns=that.state.columns;
        let typeCodeList=[];
        columns.forEach((cln,index)=>{
            if(cln.dictCode){
                typeCodeList.push(cln.dictCode)
            }
            if(cln.children&&cln.children.length>0){
                cln.children.forEach((childrenCln,index)=>{
                    if(childrenCln.dictCode){
                        typeCodeList.push(childrenCln.dictCode)
                    }
                })
            }
            if(cln.ellipsis){
                cln.ellipsis={...cln.ellipsis,showTitle: true,}
            }else{
                cln.ellipsis={showTitle: true,}
            }
            if(cln.dictUrl){
                let res;
                if(cln.urlMethod==='get'){
                    res=get(cln.dictUrl)
                }else{
                    res=postSync(cln.dictUrl)
                }
                res.then(response => {
                    let oriRender=cln.render;
                    cln.render=function(text, record, index){
                        if(isEmpty(text)){
                            if(oriRender){
                                return oriRender(text, record, index);
                            }
                            return '';
                        }
                        let textArr =text.toString().split(',');
                        let textArrTemp=[];
                        for(let j=0;j<response.length;j++){
                            if(textArr.length===1){
                                if (text === response[j].value) {
                                    if (oriRender) {
                                        return oriRender(response[j].name, record, index);
                                    }
                                    return response[j].name;
                                }
                            }else{
                                if(textArr.length>0&&textArr.indexOf(response[j].value)>=0){
                                    textArrTemp.push(response[j].name);
                                }
                            }
                        }
                        if(textArr.length===1){
                            return "";
                        }
                        if(textArrTemp&&textArrTemp.length>0){
                            text=textArrTemp.join(",");
                        }
                        if(oriRender){
                            return oriRender(text, record, index);
                        }
                        return text
                    }
                    that.setState({});
                })
            }
            // if(cln.render){
            //     const oriRender= cln.render;
            //     cln.render=(text,record,index)=>{
            //         let data = oriRender(text,record,index);
            //         return <Tooltip placement="topLeft" title={data}>{data}</Tooltip>
            //     }
            // }else{
            //     cln.render=(text,record,index)=>{
            //         return <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            //     }
            // }
            if(cln.dataIndex==='_index'){
                const oriRender= cln.render;
                cln.render=(text,record,index)=>{
                    let pageIndex = that.state.loadParams.pageIndex;
                    let pageSize = that.state.loadParams.pageSize;
                    let pageSizeParam = cookie.load("gridPageSizeParam");
                    if(isEmpty(pageSizeParam)){
                        pageSizeParam = 15;
                    }
                    let renderText = ((pageIndex?pageIndex:0)*(pageSize?pageSize:pageSizeParam)+index+1)+"";
                    if(oriRender){
                        return oriRender(renderText,record,index);
                    }else{
                        return(
                            <span>{renderText}</span>
                        )
                    }
                }
            }
            cln._index=index;
        });
        if(typeCodeList.length){

            postSync('aisino/portalIndex/getDictText', {typeCodeList:typeCodeList}).then(response => {
                if (!isEmpty(response)) {
                    //获取dictTextArr
                    let dictTextArr=response;
                    that.state.dictArr = response;
                    let dictCodeArr=[];
                    columns.forEach((cln2)=>{
                        if(cln2.dictCode){
                            dictCodeArr.push(cln2)
                        }
                        if(cln2.children&&cln2.children.length>0){
                            cln2.children.forEach((childrenCln2,index)=>{
                                if(childrenCln2.dictCode){
                                    dictCodeArr.push(childrenCln2)
                                }
                            })
                        }
                    });
                    if(dictCodeArr&&dictCodeArr.length>0){
                        dictCodeArr.forEach((cln2)=>{
                            if(cln2.dictCode){
                                let oriRender=cln2.render;
                                cln2.render=function(text, record, index){
                                    if(isEmpty(text)){
                                        if(oriRender){
                                            return oriRender(text, record, index);
                                        }
                                        return '';
                                    }
                                    let textArr =text.toString().split(',');
                                    let textArrTemp=[];
                                    for(let i=0;i<dictTextArr.length;i++){
                                        if(dictTextArr[i].typeCode===cln2.dictCode){
                                            let dictList = dictTextArr[i].dictList;
                                            for(let j=0;j<dictList.length;j++){
                                                if(text==dictList[j].value){
                                                    if(oriRender) {
                                                        return oriRender(dictList[j].name,record,index);
                                                    }
                                                    return dictList[j].name;
                                                }
                                                if(textArr.length>0&&textArr.indexOf(dictList[j].value)>=0){
                                                    textArrTemp.push(dictList[j].name);
                                                }
                                            }
                                            if(textArrTemp&&textArrTemp.length>0){
                                                text=textArrTemp.join(",");
                                            }
                                            if(oriRender){
                                                return oriRender(text, record, index);
                                            }
                                            if(textArr.length===1){
                                                return "";
                                            }
                                            return text
                                        }
                                    }
                                }
                            }
                        })
                    }
                }

                columns = columns.map((col, index) => ({
                    ...col,
                    onHeaderCell: column => ({
                        width: column.width,
                        onResize: this.handleResize(index),
                    }),
                }));
                this.setState({
                    columns:columns
                })
            })
        }else{

            columns = columns.map((col, index) => ({
                ...col,
                onHeaderCell: column => ({
                    width: column.width,
                    onResize: this.handleResize(index),
                }),
            }));
            this.setState({
                columns:columns
            })
        }
    }
    //获取行位置
    getRowIndex(row){
        if(row){
            const data=this.state.dataSource
            for(let i=0;i<data.length;i++){
                if(row._rowKey===data[i]._rowKey){
                    return i;
                }
            }
        }else{
            return null;
        }
    }
    getRowByIndex(index){
        return this.state.dataSource[index];
    }
    //添加新行
    addRow=(newRow,index)=>{
        newRow._rowKey=this.state.rowKeyNum++;
        newRow._changeFlag=added;
        // if(!newRow.id){
        //     newRow._rowKey=new Date().getTime()+"";
        // }else{
        //     newRow._rowKey=newRow.id;
        // }

        if(isEmpty(index)){
            this.state.dataSource=[...this.state.dataSource,newRow]
        }else{
            this.state.dataSource.splice(index,0,newRow);
        }
        this.setState({});
    };
    //添加新行
    addRows=(newRows,index)=>{
        //let index1=0;
        newRows.forEach(item=>{
            item._rowKey=this.state.rowKeyNum++;
            item._changeFlag=added;
            if(!isEmpty(index)){
                this.state.dataSource.splice(index++,0,item);
            }
            // if(!item.id){
            //     item._rowKey=new Date().getTime()+""+index1++;
            // }else{
            //     item._rowKey=item.id;
            // }
        });
        if(isEmpty(index)){
            this.state.dataSource=[...this.state.dataSource,...newRows];
        }
        // console.log(this.state.dataSource);
        this.setState({
            dataSource:[].concat(this.state.dataSource)
        });
    };
    //获取当前列表行数
    size(){
        return this.state.dataSource.length;
    }
    //更新选中行
    updateRow=newRow=>{
        let dataSource=this.state.dataSource;
        if(isEmpty(newRow)){
            return;
        }
        newRow._changeFlag=modified;
        const rowKey = newRow._rowKey;
        dataSource.forEach((item,index,data)=>{
            if(item._rowKey===rowKey){
                dataSource[index]=newRow;
            }
        });
        this.state.dataSource=[].concat(dataSource);
        this.setState({})
    }
    //删除选中行
    deleteRow=row=>{
        let data=this.state.dataSource;
        if(isEmpty(row)){
            return;
        }
        const rowKey = row._rowKey;
        data.forEach((item,index,data)=>{
            if(item._rowKey===rowKey){
                data.splice(index,1);
            }
        });
        this.setState({
            dataSource:[].concat(data),
        })
    }
    //删除选中的所有行
    deleteRows=rows=>{
        let data=this.state.dataSource;
        if(!isEmpty(rows)&&rows.length>0){
            for(let i=0;i<rows.length;i++){
                let row= rows[i]
                if(isEmpty(row)){
                    return;
                }
                data.forEach((item,index,data)=>{
                    if(item._rowKey===row._rowKey){
                        data.splice(index,1);
                    }
                });
            }
            this.setState({
                dataSource:[].concat(data),
            })
        }
    };
    findRows=(fun)=>{
        const data = this.state.dataSource;
        let res=[];
        if(data&&data.length>0){
            data.forEach(item=>{
                if(fun(item)){
                    res.push(item);
                }
            })
        }
        return res;
    };
    findRow=(fun)=>{
        const data = this.state.dataSource;
        if(data&&data.length>0){
            for(let i=0;i<data.length;i++){
                if(fun(data[i])){
                    return data[i];
                }
            }
        }
        return null;
    };
    //获取被选中行
    getSelectedRow=()=>{
        let selectedRows=this.getSelectedRows();
        return selectedRows[0];
    }
    //获取被选中行数组
    getSelectedRows=()=>{
        const that = this;
        const data = that.state.dataSource;
        const selectedRowKeys = that.state.selectedRowKeys;
        if(!isEmpty(selectedRowKeys)||selectedRowKeys.length>0){
            let selectedRows=[];
            data.forEach((item,index,data)=>{
                if(selectedRowKeys.indexOf(item._rowKey)>-1){
                    selectedRows.push(item);
                }
                let children=item.children;
                if(children&&children.length>0){
                    children.forEach((childItem)=>{
                        if(selectedRowKeys.indexOf(childItem._rowKey)>-1){
                            selectedRows.push(childItem);
                        }
                    })
                }
            });
            return clone(selectedRows);
        }else{
            return [];
        }
    };
    selectRow=row=>{
        const that = this;
        that.state.selectedRowKeys=[...that.state.selectedRowKeys,row._rowKey];
        that.setState({})
    };
    selectRows=rows=>{
        const that = this;
        let selectedRowKeys=that.state.selectedRowKeys;
        if(rows&&rows.length>0){
            rows.forEach(item=>{
                if(!isEmpty(item._rowKey)&&selectedRowKeys.indexOf(item._rowKey)<0){
                    selectedRowKeys=[...selectedRowKeys,item._rowKey];
                }
            })
        }
        that.setState({
            selectedRowKeys:selectedRowKeys
        })
    };
    deselectAll=row=>{
        const that = this;
        let rowKeys = [];
        that.setState({
            selectedRowKeys: [].concat(rowKeys)
        })
    }
    deselectRow=row=>{
        const that = this;
        let rowKeys = that.state.selectedRowKeys;
        if(rowKeys.indexOf(row._rowKey)>-1){
            rowKeys.splice(rowKeys.indexOf(row._rowKey),1);
            that.setState({
                selectedRowKeys: [].concat(rowKeys)
            })
        }
    }
    deselectRows=rows=>{
        const that = this;
        let rowKeys = that.state.selectedRowKeys;
        if(rows&&rows.length>0){
            for(let i=0;i<rows.length;i++){
                let row = rows[i];
                if(rowKeys.indexOf(row._rowKey)>-1) {
                    rowKeys.splice(rowKeys.indexOf(row._rowKey), 1);
                }
            }
            that.setState({
                selectedRowKeys: [].concat(rowKeys)
            })
        }
    }
    //获取默认的 行选择配置
    getDefaultSelection=selection=>{
        const  that = this ;
        if(selection===false){
            return;
        }
        let rowClickFun =null;
        let sonSelectFun=null;
        let sonSelectAllFun=null;
        if(!isEmpty(this.props.onRow)){
            let rowFun=this.props.onRow();
            rowClickFun = rowFun.onClick;
        }
        if(!isEmpty(selection)&&selection!==false){
            sonSelectFun=selection.onSelect;
            sonSelectAllFun=selection.onSelectAll;
        }
        const onSelect=function(record, selected, selectedRows, nativeEvent){
            let selectedRowKeys=that.state.selectedRowKeys;
            if(selected){
                if(that.state.selectionType==='radio'){
                    that.state.selectedRowKeys=[record._rowKey];
                }else{
                    that.state.selectedRowKeys=[...selectedRowKeys,record._rowKey];
                }
                if(!isEmpty(rowClickFun)){
                    rowClickFun(selectedRows[selectedRows.length-1]);
                }
            }else{
                if(selectedRowKeys.indexOf(record._rowKey)>=0){
                    selectedRowKeys.splice(selectedRowKeys.indexOf(record._rowKey),1)
                    that.state.selectedRowKeys=[].concat(selectedRowKeys);
                }
            }
            if(sonSelectFun){
                sonSelectFun(record, selected, selectedRows, nativeEvent)
            }
            that.setState({});
        };
        const onSelectAll = function(selected, selectedRows, changeRows){
            let selectedRowKeys=that.state.selectedRowKeys;
            if(selected){
                changeRows.forEach(item=>{
                    if(item&&selectedRowKeys.indexOf(item._rowKey)<0){
                        selectedRowKeys=[...selectedRowKeys,item._rowKey];
                    }
                })
            }else{
                changeRows.forEach(item=>{
                    if(item&&selectedRowKeys.indexOf(item._rowKey)>=0){
                        selectedRowKeys.splice(selectedRowKeys.indexOf(item._rowKey),1);
                    }
                });
            }
            if(sonSelectAllFun){
                sonSelectAllFun(selected, selectedRows, changeRows);
            }
            that.state.selectedRowKeys=[].concat(selectedRowKeys);
            that.setState({});
        };
        if(isEmpty(selection)){
            this.state.selectionType="radio";
            this.state.rowSelection= { type:"radio",onSelect:onSelect,onSelectAll:onSelectAll};
        }else{
            let selectType = selection.type?selection.type:"radio";
            this.state.selectionType=selectType;
            selection.type = selectType;
            selection.onSelect=onSelect;
            selection.onSelectAll=onSelectAll;
            this.state.rowSelection= selection;
        }
    };
    //处理行点击事件的方法
    rowClickHandle(record){
        const that= this;
        let selectionType = that.state.selectionType;
        let rowKeys = that.state.selectedRowKeys;
        if(selectionType==='radio'){
            if(rowKeys.indexOf(record._rowKey)<0){
                that.state.selectedRowKeys= [record._rowKey];
                that.setState({})
            }
        }else{
            if(rowKeys.indexOf(record._rowKey)>-1){
                rowKeys.splice(rowKeys.indexOf(record._rowKey),1);
                that.state.selectedRowKeys=[].concat(rowKeys);
                that.setState({})
            }else{
                that.state.selectedRowKeys= [...that.state.selectedRowKeys,record._rowKey];
                that.setState({})
            }
        }
    }
    //行方法绑定
    onRowFun(record){
        const that = this;
        if(isEmpty(this.props.onRow)){
            return {
                onClick: () => {
                    that.rowClickHandle(record)
                }
            }
        }else{
            let funObject=this.props.onRow();
            const clickFun = funObject.onClick;
            funObject.onClick=()=>{
                that.rowClickHandle(record);
                if(!isEmpty(clickFun)) {
                    clickFun(record);
                }
            };
            const onDoubleClickFun = funObject.onDoubleClick;
            funObject.onDoubleClick=()=>{
                if(!isEmpty(onDoubleClickFun)) {
                    onDoubleClickFun(record);
                }
            };
            return funObject
        }
    }
    //显示列
    showColumns(cols){
        if(cols&&cols.length>0){
            let hiddenCols=this.state.hiddenCols;
            let columns = this.state.columns;
            let i=-1;
            cols.forEach(colName=>{
                hiddenCols.forEach((item,index)=>{
                    if(colName===item.dataIndex){
                        this.addColumns(columns,item);
                        i=index;
                    }
                });
                if(i>=0){
                    hiddenCols.splice(i,1);
                    i=-1;
                }
            });
            this.state.columns=[].concat(columns);
            this.setState({});
        }
    }
    addColumns(columns,item){
        let index=0;
        for(let i=0;i<columns.length;i++){
            if(columns[i]._index<item._index){
                index=i;
            }
        }
        columns.splice(index+1,0,item);
    }
    showColumn(col){
        if(col){
            let hiddenCols=this.state.hiddenCols;
            let columns = this.state.columns;
            let i=-1;
            hiddenCols.forEach((item,index)=>{
                if(col===item.dataIndex){
                    this.addColumns(columns,item);
                    i=index;
                }
            });
            if(i>=0){
                hiddenCols.splice(i,1);
                this.state.columns=[].concat(columns);
                this.setState({});
            }
        }
    }
    //隐藏列
    hideColumns(cols){
        if(cols&&cols.length>0){
            let hiddenCols=this.state.hiddenCols;
            let columns = this.state.columns;
            cols.forEach(col=>{
                let index=-1;
                for(let i=0;i<columns.length;i++){
                    if(col===columns[i].dataIndex){
                        index=i;
                        if(hiddenCols.indexOf(columns[i])==-1){
                            hiddenCols.push(columns[i])
                        }
                    }
                }
                if(index>=0){
                    columns.splice(index,1);
                }
            });
            this.state.columns=[].concat(columns);
            this.setState({});
        }
    }
    hideColumn(col){
        if(col){
            let hiddenCols=this.state.hiddenCols;
            let columns = this.state.columns;
            let index=-1;
            for(let i=0;i<columns.length;i++){
                if(col===columns[i].dataIndex){
                    index=i;
                    hiddenCols.push(columns[i])
                }
            }
            if(index>=0){
                columns.splice(index,1);
            }
            this.state.columns=[].concat(columns);
            this.setState({});
        }
    }
    updateColumn(dataIndex,object){
        let columns = this.state.columns;
        for(let i=0;i<columns.length;i++){
            if(dataIndex===columns[i].dataIndex){
                for(let key in object){
                    columns[i][key]=object[key];
                }
            }
        }
        this.state.columns=[].concat(columns);
        this.setState({});
    }
    getTotalCount(){
        return this.state.total;
    }
    exportToExcel=params=>{
        if(this.state.total>getExportLimit()){
            aisinoInfoModal(commonLan.exportDataCannotExceed+getExportLimit());
            return ;
        }
        const that= this;
        params={...params,...that.state.loadParams};
        let dictArr=that.state.dictArr;
        params.pageIndex="";
        params.pageSize="";
        let dictionaryList = {};
        if(dictArr.length>0&&!isEmpty(params.dictCols)){
            let dictCols=params.dictCols;
            const columns = that.state.columns;
            columns.forEach(col=>{
                if(dictCols.indexOf(col.dataIndex)>=0){
                    dictArr.forEach(dict=>{
                        if(col.dictCode===dict.typeCode){
                            dictionaryList[col.dataIndex]=dict.dictList;
                        }
                    });
                }
            });
        }
        if(JSON.stringify(dictionaryList)!=="{}"){
            const jsonString = JSON.stringify(dictionaryList, (key, value) => {
                return value === null ? undefined : value;
            });
            dictionaryList = JSON.parse(jsonString);
        }
        params.dictionaryList=dictionaryList;
        let printParams=this.dealListPrintParams(params,"aisino/export/exportData","directExport");
        let servername="invoice";
        if(isEmpty(params['actionUrl'])){
            if(that.state.loadUrl.startsWith("/")){
                servername = that.state.loadUrl.split("/")[1];
                let tempUrl = that.state.loadUrl.substring(1);
                params['actionUrl'] = tempUrl.substring(tempUrl.indexOf("/"));
            }else{
                params['actionUrl'] = that.state.loadUrl;
            }
        }
        let downloadFileUrl= window.g.baseURL+"/"+servername+"/aos/print/directexport?noEncrypt=true";
        var form = $("<form>")
        form.attr("style","display:none");
        form.attr("targat","");
        form.attr("method","post");
        form.attr("action",downloadFileUrl);
        for (var key in printParams) {
            var input1 = $("<input>")
            input1.attr("type","hidden")
            input1.attr("name",key)
            input1.attr("value",typeof printParams[key] == "object" ? JSON.stringify(printParams[key]) : printParams[key])
            form.append(input1);
        }

        $("body").append(form);
        form.submit()
        let dom = document.createElement('div');
        dom.setAttribute('id', 'exportData');
        document.body.appendChild(dom);
        ReactDOM.render(<Spin wrapperClassName='react-loadings' size="large" spinning={true} tip={commonLan.dataExportPleaseWait}></Spin>, dom);
        var icount = setInterval(()=>{
            post("aisino/export/getExportResult").then((rtnData)=>{
                if(rtnData == true){
                    clearInterval(icount);
                    this.removeLoading();
                }
            })
        }, 10000);
    }
    removeLoading(){
        document.body.removeChild(document.getElementById('exportData'));
    }
    dealListPrintParams(params,F,C){
        let printColumn =this.getGridColumnInfo(params.notShowCols==undefined ?[]:params.notShowCols);
        // console.log(printColumn);
        if(!("printtitle"in params))params.printtitle="1234";
        params.printColumn=printColumn;
        params.ajaxUrl=F;
        params.action=C;
        //$.canvasPath=canvasPath;
        return params
    }
    getGridColumnInfo(notShowCols){
        let columns = this.state.columns;
        let hasChildRow=false;
        for(let HCI=0;HCI<columns.length;HCI++){
            if(columns[HCI].children!=null&&columns[HCI].children.length>0){
                hasChildRow=true;
                break;
            }
        }
        let B=[],G=columns,C=function(J){
            let notShowColNum=0;
            let childNum = 0;
            for(let I=0;I<J.length;I++){
                let A=J[I];
                if(notShowCols.find(e=>e===A.dataIndex)!==undefined){
                    notShowColNum++;
                    continue;
                }//检测导出是否忽略该列
                if(A.dataIndex === "variable"){
                    notShowColNum++;
                    continue;
                }
                //增加双行表头处理(暂不支持隐藏子表头列)
                if(typeof A.title === 'function'){
                    return;
                }
                let K={cid:A.dataIndex,text:A.title!=null?A.title.trim():"",align:A.align,
                    width:A.width?A.width:100,level:1,
                    rowIndex:0,colIndex:(I+childNum-notShowColNum),hasChild:false,
                    rowspan:1,colspan:1,
                    renderer:typeof(A.renderer)=="string"?A.renderer:null};
                if(A.dataIndex==='_index')
                    K.cid="grid_seq_id";
                if(hasChildRow){
                    if(A.children!=null&&A.children.length>0){
                        K.hasChild = true;
                        K.colspan = A.children.length;
                        B.push(K);
                        for(let M=0;M<A.children.length;M++){
                            let KC={
                                cid:A.children[M].dataIndex,text:A.children[M].title!=null?A.children[M].title.trim():"",align:A.children[M].align,
                                width:A.children[M].width?A.children[M].width:100,level:2,
                                rowIndex:1,colIndex:(I+childNum-notShowColNum+M),hasChild:false,
                                rowspan:1,colspan:1,
                                renderer:typeof(A.renderer)=="string"?A.renderer:null};
                            B.push(KC);
                        }
                        childNum+=(A.children.length-1);
                    }else{
                        K.rowspan = 2;
                        B.push(K);
                    }
                }else{
                    B.push(K);
                }
            }
        };
        C(G);
        return B
    }
    isChanged(){
        let dataSource=this.state.dataSource;
        let flag=false;
        dataSource.forEach((item)=>{
            if(!isEmpty(item._changeFlag)){
                flag=true;
            }
        });
        return flag
    }
    getChanges(type){
        let arr=[];
        let dataSource=this.state.dataSource;
        dataSource.forEach((item)=>{
            if(!isEmpty(item._changeFlag)){
                if(isEmpty(type)){
                    arr.push(item);
                }else{
                    if(item._changeFlag===type){
                        arr.push(item);
                    }
                }
            }
        });
        return arr;
    }

    render() {
        const that=this;

        if(this.state.variableTitles && this.state.variableTitles.length > 0){
            //说明要显示表头控制
            this.state.rowSelection = {
                ...this.state.rowSelection,
                columnTitle: (
                    <div style={{display:'flex',alignItems:'center',justifyContent:'center',position:'relative'}}>
                        <SettingOutlined ref={(ref) => this.headBtnRef = ref} style={{ color: '#fff',position:'absolute',left:-4 }} onClick={this.selectClick}/>
                        <Checkbox
                            indeterminate={this.state.rowIndeterminate}
                            checked={this.state.rowCheckAll}
                            onChange={this.onRowCheckAllChange}
                            disabled={this.state.dataSource.length === 0}
                        />
                    </div>
                ),
                renderCell: (checked, record) => (
                    <Checkbox
                        checked={this.state.selectedRowKeys.includes(record._rowKey)}
                        onChange={() => this.onRowSelectChange(checked, record._rowKey)}
                    />
                ),
            };
        }

        return (
            <div style={{ position: 'relative'}}>
                <ConfigProvider
                    renderEmpty={() => (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={commonLan.noData}
                        />
                    )}
                >
                    <Table
                        bordered
                        components={this.components}
                        {...this.props}
                        rowKey={record => record._rowKey}
                        dataSource={this.state.dataSource}
                        columns={this.state.columns}
                        size={this.props.size?this.props.size:'middle'}
                        pagination={this.props.pagination===false?false:this.state.pagination}
                        scroll={this.props.scroll?this.props.scroll:{y:500,x:0}}
                        style={{...this.props.style}}
                        tableLayout={this.props.tableLayout?this.props.tableLayout:'fixed'}
                        rowSelection={this.props.rowSelection===false?false:{...this.state.rowSelection,selectedRowKeys:this.state.selectedRowKeys}}
                        onRow={record => {
                            return that.onRowFun(record);
                        }}
                        rowClassName={(record, index) => {
                            if(this.props.rowClassName != undefined){
                                let rowClassName = this.props.rowClassName(record);
                                if(!isEmpty(rowClassName)){
                                    return rowClassName;
                                }
                            }
                            let className = 'light-row';
                            if (index % 2 === 1) className = 'dark-row';
                            return className;
                        }}
                        summary={that.state.sumData ? () => (
                            <Table.Summary.Row>
                                {this.props.rowSelection !== false && <Table.Summary.Cell>{commonLan.total}</Table.Summary.Cell>}
                                {that.state.columns.map(column => (
                                    <Table.Summary.Cell key={column.dataIndex} style={{ width: column.width }}>
                                        <Text>{ that.state.sumData[column.dataIndex] || "" }</Text>
                                    </Table.Summary.Cell>
                                ))}
                            </Table.Summary.Row>
                        ): null}
                    />
                </ConfigProvider>
                {/* 根据checkBoxShow的状态来控制目标组件的显示和隐藏 */}
                {this.state.checkBoxShow && (
                    <div ref={(ref) => this.checkboxRef = ref}
                         style={{ position: 'absolute', top: 30, left: 10, width:280, height:250, background:'white', zIndex: 99,
                             borderRadius: 2, padding:10,  boxShadow: '0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d'
                         }}>
                        <Checkbox indeterminate={this.state.indeterminate} onChange={this.onCheckAllChange} checked={this.state.checkAll}>
                            {commonLan.checkAll}
                        </Checkbox>
                        <Checkbox.Group
                            style={{display:"flex",flexDirection:"column", maxHeight: 218, paddingLeft:20,
                                overflowY:this.state.options.length * 22 > 218 ? 'auto' : 'none'}}
                            value={this.state.checkedList}
                            onChange={this.onCheckboxChange}
                            options={this.state.options}
                        />
                    </div>
                )}
            </div>

        )
    }
}
export default AisinoTable;
